import { useHistory } from "react-router-dom";

import useQuery from "hooks/useQuery";

import { DEFAULT_TARIFF_TAB, TARIFF_TABS } from "features/Tariff/constants";
import { TariffTab } from "features/Tariff/types";

const isTariffTab = (value: string | undefined): value is TariffTab =>
    TARIFF_TABS.some((tab) => tab.key === value);

// Активный таб живёт в ?tab=; пишем через replace, чтобы «назад» браузера не листал табы.
export const useActiveTab = (): [TariffTab, (tab: TariffTab) => void] => {
    const history = useHistory();
    const { tab } = useQuery<{ tab?: string }>();

    const activeTab: TariffTab = isTariffTab(tab) ? tab : DEFAULT_TARIFF_TAB;

    const setActiveTab = (next: TariffTab) => {
        const params = new URLSearchParams(history.location.search);
        params.set("tab", next);
        history.replace({ search: params.toString() });
    };

    return [activeTab, setActiveTab];
};
